import React, { Component } from "react";

import moment from "moment";

export default class Resposta extends Component {
  state = {
    respostas: this.props.respostas,
    isVisible: true,

  };

  /*_setVisibility = e => {
    e.preventDefault();
    //this.setState({ isVisible: !this.state.isVisible });
    //this.state.isVisible = !this.state.isVisible;
    //this.forceUpdate();
  };
  */

  /*constructor(props) {
    super(props);
    
    //const { idPaciente, idHistorico, idComentario, idComent, respostas } = this.props;

    //var listRespostas = respostas;
    //this.setState({ respostas: listRespostas })

    
    
    

    /*Libfirebase.collection("paciente")
      .doc(idPaciente)
      .collection("historico")
      .doc(idHistorico)
      .collection("Comentarios")
      .doc(idComent)
      .collection("Resposta")
      .get()
      .then(snap => {
        
        snap.forEach(doc => {
          doc
            .data()
            .refProfissional.get()
            .then(prof => {
              const data = {
                id: doc.id,
                comentario: doc.data(),
                profissional: prof.data(),
                idProfissional: prof.id
              };

              listRespostas.push(data);
              this.setState({ respostas: listRespostas });
            });
        });
        
        
      })
      
  }*/

  componentDidMount() {
    const { idPaciente, idHistorico, idComentario, idComent, respostas } = this.props;
    //this.state.respostas = respostas;
    var listRespostas = respostas;

    this.setState({ respostas: listRespostas })


  }


  render() {

    return (
      <div className="col-sm-10 m-3">

        {this.props.respostas
          ? this.props.respostas.sort(
            function (a, b) {

              if (parseInt(a.comentario.dataHoraCriacao) < parseInt(b.comentario.dataHoraCriacao)) {
                return -1;
              }
              if (parseInt(a.comentario.dataHoraCriacao) > parseInt(b.comentario.dataHoraCriacao)) {
                return 1;
              }
              return 0;
            }
          )

            .map((resposta, index) => {
              return (
                <div key={index}>

                  <div
                    style={{
                      padding: "10px",
                      borderBottom: "1px solid #f5f5f5"
                    }}
                    className="row"
                  >
                    <div className="col-sm-2 text-center">
                      <img
                        style={{
                          width: "50px",
                          height: "50px",
                          marginRight: "10px",
                          borderRadius: "50%"
                        }}
                        src={resposta.profissional.avatarURL ?
                          resposta.profissional.avatarURL :
                          "https://firebasestorage.googleapis.com/v0/b/globalbrain-ba498.appspot.com/o/images%2Fno-user.jpg?alt=media&token=44616cc9-46e2-40ea-906f-28e46f58fb68"
                        }
                        alt="Foto Perfil"
                      />

                    </div>

                    <div className="col-sm-8">

                      <span style={{ fontSize: "11px", marginBottom: "12px" }}>
                        <b>{resposta.profissional.nome}</b>
                        - <i>{moment(resposta.comentario.data).format(
                          "DD/MM/YYYY HH:mm:ss"
                        )}</i>
                      </span>
                      <br />
                      {resposta.comentario.resposta}

                    </div>
                  </div>

                </div>
              );
            })
          : null}
      </div>
    );
  }
}

